// src/features/user/userSaga.js
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { getSyscoShopAuthToken, getSyscoShopAuthTokenSuccess, getSyscoShopAuthTokenError } from '../slice/authShopSlice';
import { ApiClient } from "../../components/utils/apiClient";
import { BFF_URL } from '../../constant/stringConstants';
import { setServerErrors } from '../slice/appSlice';

function* getAuthCredentials(action) {
  try {
    const authApiClient = new ApiClient(BFF_URL);
    const orderReferenceId = action.payload;
    const response = yield call([authApiClient, authApiClient.get], `/auth/credentials/${orderReferenceId}`);
    yield put(getSyscoShopAuthTokenSuccess(response));
  } catch (error) {
    yield put(setServerErrors(true));
    yield put(getSyscoShopAuthTokenError(error.data));
  }
}

export default function* processAll() {
  yield all([takeLatest(getSyscoShopAuthToken.type, getAuthCredentials)]);
}
